import { Component, Inject } from '@angular/core'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Documentos } from 'src/app/models/documenos'
import { PropgService } from 'src/app/services/propg-service'
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component'

@Component({
  selector: 'app-documentos-viewer',
  templateUrl: './documentos-viewer.component.html',
  styleUrls: ['./documentos-viewer.component.css'],
  standalone: false
})
export class DocumentosViewerComponent {
  constructor(
    public dialogRef: MatDialogRef<DocumentosViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Documentos,
    public dialog: MatDialog,
    private propgService: PropgService
  ) {}

  download(folder: string, title: string, idInscricao: number): void {
    this.propgService.download(folder, idInscricao).subscribe(data => {
      let blob = new Blob([data], {
        type: 'application/pdf',
      })
      let url = window.URL.createObjectURL(blob)
      this.dialog.open(PdfViewerComponent, {
        data: {
          titulo: title,
          url: url,
        },
        width: '80%',
        height: '90%',
      })
    })
  }
}
